"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildTxToSign = void 0;
const hdwallet_core_1 = require("@shapeshiftoss/hdwallet-core");
const web3_utils_1 = require("web3-utils");
function toPath(bip44Params) {
    const { purpose, coinType, accountNumber, isChange = false, index = 0 } = bip44Params;
    if (typeof purpose === 'undefined')
        throw new Error('toPath: bip44Params.purpose is required');
    if (typeof coinType === 'undefined')
        throw new Error('toPath: bip44Params.coinType is required');
    if (typeof accountNumber === 'undefined')
        throw new Error('toPath: bip44Params.accountNumber is required');
    return `m/${purpose}'/${coinType}'/${accountNumber}'/${Number(isChange)}/${index}`;
}
function buildTxToSign({ bip44Params, chainId = 1, data, estimatedGas, gasPrice, nonce, to, value }) {
    const path = toPath(bip44Params);
    const addressNList = (0, hdwallet_core_1.bip32ToAddressNList)(path);
    return {
        addressNList,
        value: (0, web3_utils_1.numberToHex)(value),
        to,
        chainId,
        data,
        nonce: (0, web3_utils_1.numberToHex)(nonce),
        gasPrice: (0, web3_utils_1.numberToHex)(gasPrice),
        gasLimit: (0, web3_utils_1.numberToHex)(estimatedGas)
    };
}
exports.buildTxToSign = buildTxToSign;
